<template>
    <CSidebar fixed
              :minimize="minimize"
              :show="show"
              colorScheme='dark'
              @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" to="/home">

            <img :src="imageSrc" class="c-sidebar-brand-full" :style="{ height: logoHeight + 'px' }" />
            <img src="../../public/logo/secure_small_white_v3.png" class="c-sidebar-brand-minimized" height="35" />
        </CSidebarBrand>

        <CRenderFunction flat :content-to-render="$store.state.navBarItems" />
        
        <CSidebarMinimizer class="d-md-down-none"
                           @click.native="$store.commit('set', ['sidebarMinimize', !minimize])" :select="onMinimize()"/>
    </CSidebar>
</template>

<script>
    export default {
        name: 'TheSidebar',
        data() {
            return {
                imageSrc: "",
                logoHeight: 35
            };
        },
        computed: {
            show() {
                return this.$store.state.sidebarShow
            },
            minimize() {
                return this.$store.state.sidebarMinimize

            },
           
        },
        mounted() {
            this.setImageSource();
        },
        methods: {
            onMinimize: function (e) {

                var chartMap = document.getElementById("containerPower_svg");
                if (chartMap != null) {
                    if (this.minimize == true) {
                        this.$store.state.homeRegionMap.width = "870px";
                    } else {
                        this.$store.state.homeRegionMap.width = "774px";


                    }
                }
            },
            setImageSource() {
                if (process.env.NODE_ENV !== 'production') {
                    this.imageSrc = '/logo/secure_demo_v3.png';
                    this.logoHeight = 40;
                } else {
                    this.imageSrc = '/logo/secure_v3.png';
                    this.logoHeight = 35;
                }

            }
        }

    }
</script>



